import { httpApi } from '@api/http.api.ts';

export interface NotActivatedUserStatusResponse {
    status: string;
}

export interface AuthRequest {
    email: string;
    password: string;
}

export interface LoginResponse {
    accessToken: string;
    refreshToken: string;
    refreshTokenExpiresAtUTC: string;
    requiresRegistration: boolean;
}

export interface ResetPasswordRequest {
    email: string;
    callbackUrl: string;
}

export interface ResetPasswordResponse {
    message: string;
}

export interface changeInitialPasswordRequest {
    email: string;
    initialPassword: string;
    password: string;
}

export type RefreshTokenResponse = LoginResponse;

export interface RefreshTokenRequest {
    refreshToken: string;
}

export const userStatus = (statusPayload: AuthRequest): Promise<NotActivatedUserStatusResponse> =>
    httpApi
        .post<NotActivatedUserStatusResponse>(`users/status`, {
            ...statusPayload,
        })
        .then(({ data }) => data);

export const login = (loginPayload: AuthRequest): Promise<LoginResponse> =>
    httpApi.post<LoginResponse>(`auth/login`, { ...loginPayload }).then(({ data }) => data);

export const activateUser = (termPasswordPayload: changeInitialPasswordRequest): Promise<LoginResponse> =>
    httpApi.post<LoginResponse>(`users/activate`, { ...termPasswordPayload }).then(({ data }) => data);

export const resetPassword = (resetPasswordPayload: ResetPasswordRequest): Promise<ResetPasswordResponse> =>
    httpApi.put<ResetPasswordResponse>(`auth/password-reset`, { ...resetPasswordPayload }).then(({ data }) => data);

export const postRefreshToken = (payload: RefreshTokenRequest): Promise<RefreshTokenResponse> =>
    httpApi.post<RefreshTokenResponse>(`auth/token-refresh`, { ...payload }).then(({ data }) => data);
